<template>
    <div class="regbox" style="margin-top:60px;">
        <div class="item">
            <div class="label reg-must">公司全称</div>
            <div class="value input-box">
                <input type="text" maxlength="18" v-model="name" @blur="nameBlur" placeholder="请填写您公司的名称">
            </div>
        </div>
        <div class="item">
            <div class="label reg-must">公司简称</div>
            <div class="value input-box">
                <input type="text" maxlength="8" v-model="shortName" placeholder="请输入您公司的简称">
            </div>
        </div>
        <div class="item">
            <div class="label reg-must">公司固话</div>
            <div class="value input-box">
                <input maxlength="18" type="text" v-model="telephone" placeholder="请输入您公司的联系方式">
            </div>
            <div class="other">如0571-888888</div>
        </div>
        <div class="item">
            <div class="label reg-must">您的姓名</div>
            <div class="value input-box">
                <input maxlength="11" type="text" v-model="adminName" placeholder="请输入您的姓名">
            </div>
        </div>
        <!-- <div class="item">
            <div class="reg-txt reg-must">您的姓名</div>
            <div class="reg-ms">
                <input maxlength="11" type="text" v-model="adminName" class="reg-inp" placeholder="请输入您的姓名">
            </div>
        </div> -->
        <div class="item">
            <div class="label reg-must">行业类型</div>
            <div class="value">
                <!-- <select v-model="industry">
                    <option value="0">请选择行业类型</option>
                    <option :key="item.id" :value="item.id + '/' + item.name" v-for="item in listIndustry">
                        {{item.name}}
                    </option>
                </select> -->
                <el-select v-model="industry" placeholder="请选择行业类型">
                    <el-option
                      v-for="item in listIndustry"
                      :key="item.value"
                      :label="item.name"
                      :value="item.id + '/' + item.name">
                    </el-option>
                </el-select>
            </div>
        </div>
        <div class="item">
            <div class="label reg-must" >logo</div>
            <div class="value">
              <el-upload
                class="uploader"
                action="/wapi/base/upload/logo"
                name="logoFile"
                :show-file-list="false"
                :on-success="handleAvatarSuccess">
                <img v-if="logoUrl" :src="logoUrl">
                <div v-else class="upload-tips">点击上传</div>
              </el-upload>
            </div>
        </div>
        <div class="item">
            <div class="label reg-must">全景大图</div>
            <div class="value">
                <!-- <input @change="quanjingChange" class="quanjing-file" type="file">
                <img v-if="!backgroundUrl" src="../../assets/images/picchuan.png" style="cursor:pointer;">
                <img v-else :src="backgroundUrl" style="cursor:pointer;"> -->
                <el-upload
                  class="uploader background-upload"
                  action="/wapi/base/upload/backgroundImg"
                  name="backgroundImageFile"
                  :show-file-list="false"
                  :on-success="handleBackSuccess">
                  <img v-if="backgroundUrl" :src="backgroundUrl" >
                  <div v-else class="upload-tips">点击上传</div>
                </el-upload>
            </div>
        </div>
        <div class="item">
            <div class="label reg-must">工厂规模</div>
            <div class="value">
                <!-- <select class="reg-inp" v-model="scale">
                    <option value="0">请选择规模</option>
                    <option :key="item" v-for="item in listScale">{{item}}</option>
                </select> -->
                <el-select v-model="scale" placeholder="请选择规模">
                    <el-option
                      v-for="item in listScale"
                      :key="item"
                      :label="item"
                      :value="item">
                    </el-option>
                </el-select>
                <!-- <span class="reg-tx">人</span> -->
            </div>
            <!-- <div class="reg-war">密码必须包括大小写、数字、且长度不得少于6位</div> -->
        </div>
        <div class="item">
            <div class="label reg-must">所属区县</div>
            <div class="value">
                <el-cascader v-model="selectOptions"
                              :options="provinceArr" @active-item-change="handleItemChange"></el-cascader>
            </div>
        </div>
        <div class="item">
            <div class="label reg-must">工厂地址</div>
            <div class="value">
                <div class="input-box m-b-20">
                  <input type="text" v-model="address" placeholder="请输入详细地址">
                </div>
                <!-- <div class="address-hint">为了帮助求职者能更准确的找到公司地址，请拖动地图定位标记到工厂实际位置</div> -->
                <!--<div class="address-map" id="container"></div>-->
                <TxMap @updateAddress="updateAddress" ref="TxMap"/>
            </div>
        </div>
        <div class="item m-b-20">
            <div class="label reg-must">工厂简介：</div>
            <div class="value textarea-box">
                <el-input
                max=300
                type="textarea"
                placeholder="请输入300字内的文本信息"
                v-model="description" resize="none">
              </el-input>
            </div>
        </div>
        <div class="primary-btn" @click="gostep">下一步</div>
    </div>
</template>
<script>
import TxMap from '../../components/TxMap.vue';
import {
    Message
} from 'element-ui'
const qs = require("qs");
export default {
  data() {
    return {
      selectOptions: [],
      logoUrl: "",
      backgroundUrl: "",
      provinceArr: [],
      citylist: [],
      props: {
        value: "id",
        label: "name"
      },
      cityArr: [],
      areaArr: [],
      streetArr: [],
      address1: 0, // 地址省份
      address2: 0, // 地址市
      address3: 0, // 地址区县
      address4: 0, // 地址镇街
      provinceIndex: 0,
      cityIndex: 0,
      areaIndex: 0,
      listIndustry: [], // 行业类型arr
      industry: null,
      listScale: [], // 企业规模arr
      name: "", //企业名称
      shortName: "", // 企业简称
      telephone: "", // 电话
      logo: "", // logo
      backgroundImage: "", // 全景大图
      scale: null, // 企业规模
      provinceId: "",
      provinceName: "",
      cityId: "",
      cityName: "",
      areaId: "",
      areaName: "",
      streetId: "",
      streetName: "",
      address: "", // 地址
      lng: "", //经度
      lat: "", // 纬度
      description: "", // 企业简介
      // map: "",
      adminName: "",
      // geocoder: "",
      isregSend: false // 是否正在提交信息中
    };
  },
  components: {
    TxMap
  },
  created() {
    this.getProvince();
    this.getIndustry();
    this.getScale();
    this.name = this.$route.query.searchtxt ? this.$route.query.searchtxt : "";
  },
  mounted() {
    // let self = this;
    // self.map = new AMap.Map("container", {
    //   zoom: 12,
    //   center: [120.699366, 27.994267],
    //   resizeEnable: false
    // });
  },
  watch: {
    address1: function(newval, oldval) {
      if (newval) {
        this.provinceIndex = this.provinceArr.findIndex(item => {
          return item.id == newval.split("-")[0];
        });
        this.getCity(newval.split("-")[0]);
      }
    },
    address2: function(newval, oldval) {
      if (newval) {
        this.cityIndex = this.cityArr.findIndex(item => {
          return item.id == newval.split("-")[0];
        });
        this.getArea(newval.split("-")[0]);
      }
    },
    address3(newval, oldval) {
      if (newval) {
        this.areaIndex = this.areaArr.findIndex(item => {
          return item.id == newval.split("-")[0];
        });
        this.getStreet(newval.split("-")[0]);
      }
    },
    selectOptions(newval, oldval) {
      this.provinceId = newval[0].split("-")[0];
      this.provinceName = newval[0].split("-")[1];
      this.cityId = newval[1].split("-")[0];
      this.cityName = newval[1].split("-")[1];
      this.areaId = newval[2].split("-")[0];
      this.areaName = newval[2].split("-")[1];
      this.streetId = newval[3].split("-")[0];
      this.streetName = newval[3].split("-")[1];
      if (newval) {
        let self = this;
        // self.map = new AMap.Map("container", {
        //   zoom: 12,
        //   center: [120.699366, 27.994267],
        //   resizeEnable: false
        // });
        // self.geocoder = new AMap.Geocoder({
        //   city: self.cityName //城市，默认：“全国”
        // });
        const addressName =  self.provinceName + self.cityName + self.areaName + self.streetName;
        self.lng = '';
        self.lat = '';
        this.$refs.TxMap.addr2latlng(addressName)
        // self.geocoder.getLocation(addressName, function(status, result) {
        //   if (status === "complete" && result.info === "OK") {
        //     self.handleGeocoder(result);
        //     let geo = result.geocodes[0].location;
        //     self.lng = geo.lng;
        //     self.lat = geo.lat;
        //   }
        // });
      }
    }
  },
  methods: {
    // 获取企业规模
    getScale() {
      this.axios.get("/wapi/baseData/listScale").then(res => {
        this.listScale = res.data;
      });
    },
    // 公司名称
    nameBlur() {
      let companyName = this.name,
        re = /浙江省|浙江|杭州市|杭州|温州市|温州|有限|股份|公司|责任/g;
      this.shortName = companyName.replace(re, function(matchvalue) {
        return "";
      });
    },
    // 获取产业类型
    getIndustry() {
      this.axios.get("/wapi/baseData/listIndustry").then(res => {
        this.listIndustry = res.data;
      });
    },
    // addMarker(d) {
    //   let marker = new AMap.Marker({
    //     map: this.map,
    //     cursor: "move",
    //     draggable: true,
    //     position: [d.location.getLng(), d.location.getLat()]
    //   });
    //   /*let infoWindow = new AMap.InfoWindow({
    //                 content: d.formattedAddress,
    //                 offset: {x: 0, y: -30}
    //             });*/
    //   let self = this;
    //   marker.on("mouseout", function(e) {
    //     self.lat = e.lnglat.lat;
    //     self.lng = e.lnglat.lng;
    //     // infoWindow.open(this.map, marker.getPosition());
    //   });
    // },
    // 地理编码返回结果展示
    // handleGeocoder(data) {
    //   let geocode = data.geocodes[0];
    //   this.addMarker(geocode);
    //   this.map.setFitView();
    // },
    // 上传logo
    logoChange(event) {
      let formdata = new FormData();
      formdata.append("logoFile", event.target.files[0]);
      this.axios.post("/wapi/base/upload/logo", formdata).then(res => {
        if (res.status * 1 == 200) {
          this.logoUrl = res.data;
        }
      });
    },
    handleAvatarSuccess(res){
       if (res.status * 1 == 200) {
          this.logoUrl = res.data;
        } else {
          Message({
            message: res.msg,
            type: 'warning'
          })
        }
    },
    handleItemChange(val) {
      if (val[0]) {
        this.address1 = val[0];
      }
      if (val[1]) {
        this.address2 = val[1];
      }
      if (val[2]) {
        this.address3 = val[2];
      }
    },
    // 上传全景大图
    quanjingChange(event) {
      let formdata = new FormData();
      formdata.append("backgroundImageFile", event.target.files[0]);
      this.axios.post("/wapi/base/upload/backgroundImg", formdata).then(res => {
        if (res.status * 1 === 200) {
          this.backgroundUrl = res.data;
        }
      });
    },
    handleBackSuccess(res){
        if (res.status * 1 === 200) {
          this.backgroundUrl = res.data;
        }else {
          Message({
            message: res.msg,
            type: 'warning'
          })
        }
    },
    getProvince() {
      this.axios.get("/wapi/baseData/listProvince").then(res => {
        this.provinceArr = res.data.map(item => {
          item.value = item.id + "-" + item.name;
          item.label = item.name;
          item.children = [];
          return item;
        });
      });
    },
    getCity(id) {
      this.axios.get("/wapi/baseData/listCity?provinceId=" + id).then(res => {
        this.cityArr = res.data;
        this.provinceArr[this.provinceIndex].children = res.data.map(
          (item, index, array) => {
            item.children = [];
            item.value = item.id + "-" + item.name;
            item.label = item.name;
            return item;
          }
        );
      });
    },
    getArea(id) {
      let xhr = new XMLHttpRequest();
      let url = "/wapi/baseData/listArea?cityId=" + id;
      xhr.open("get", url, false);
      xhr.onload = () => {
        let json = JSON.parse(xhr.response);
        this.areaArr = json.data;
        this.provinceArr[this.provinceIndex].children[
          this.cityIndex
        ].children = json.data.map(function(item, index, arr) {
          item.label = item.name;
          item.value = item.id + "-" + item.label;
          item.children = [];
          return item;
        });
      };
      xhr.send();
    },
    getStreet(id) {
      let xhr = new XMLHttpRequest();
      let url = "/wapi/baseData/listStreet?areaId=" + id;
      xhr.open("get", url, false);
      xhr.onload = () => {
        let json = JSON.parse(xhr.response);
        this.streetArr = json.data;
        this.provinceArr[this.provinceIndex].children[this.cityIndex].children[
          this.areaIndex
        ].children = json.data.map((item, index, arr) => {
          item.value = item.id + "-" + item.name;
          item.label = item.name;
          return item;
        });
      };
      xhr.send();
    },
    gostep() {
      if (!this.industry) {
        this.$message("请选择行业类型");
        return;
      }
      let qdata = {
        name: this.name, //企业名称
        shortName: this.shortName, // 企业简称
        telephone: this.telephone, // 电话
        industryId: this.industry.split("/")[0], // 行业类型id
        industryName: this.industry.split("/")[1], //行业类型name
        logo: this.logoUrl, // logo
        backgroundImage: this.backgroundUrl, // 全景大图
        scale: this.scale, // 企业规模
        provinceId: this.provinceId,
        provinceName: this.provinceName,
        cityId: this.cityId,
        cityName: this.cityName,
        areaId: this.areaId,
        areaName: this.areaName,
        streetId: this.streetId,
        streetName: this.streetName,
        address: this.address, // 地址
        lng: this.lng, //经度
        lat: this.lat, // 纬度
        adminName: this.adminName,
        description: this.description // 企业简介
      };
      let self = this;
      if (self.isregSend) {
        return;
      }
      self.isregSend = true;
      self.axios.post("/wapi/company/reg", qs.stringify(qdata)).then(res => {
        if (res.status * 1 == 200) {
          switchCompany(res.data);
          // this.$router.push({path:"/register/hrinfo"});
        } else {
          self.isregSend = false;
        }
      });

      function switchCompany(id) {
        self.axios.get("/wapi/hr/swichCompany?companyId=" + id).then(res => {
          self.isregSend = false;
          if (res.status * 1 === 200) {
            // self.$router.push({ path: "/register/hrinfo" });
            self.$router.push({path:"/register/regsuc"})
          }
        });
      }
    },
    updateAddress(result) {
      this.lng = result.location.lng;
      this.lat = result.location.lat;
    }
  }
};
</script>
<style scoped lang="less">
@import url('../../assets/less/reglogin.less');
.background-upload{
  width: 320px;
  height: 80px;
}
.primary-btn{
  margin: 0 auto;
}
</style>
<style lang="less">
.el-input__inner{
  border-color:  #E6E6E6;
}
</style>



// WEBPACK FOOTER //
// create.vue?7e9546af